import { Cwb_PositionalAttribute } from "../../../../Shared/Shared.js";
import { ofArray } from "../../../../fable_modules/fable-library.3.7.9/List.js";

export const lemma = new Cwb_PositionalAttribute("lemma", "Lemma");

export const pos = new Cwb_PositionalAttribute("pos", "Part-of-speech");

export const subclass = new Cwb_PositionalAttribute("subclass", "Subclass");

export const grade = new Cwb_PositionalAttribute("grade", "Grade");

export const number = new Cwb_PositionalAttribute("number", "Number");

export const case$ = new Cwb_PositionalAttribute("case", "Case");

export const attribute = new Cwb_PositionalAttribute("attribute", "Attribute");

export const person_number = new Cwb_PositionalAttribute("person_number", "Person number");

export const mood = new Cwb_PositionalAttribute("mood", "Mood");

export const tense = new Cwb_PositionalAttribute("tense", "Tense");

export const nominal_verb_form = new Cwb_PositionalAttribute("nominal_verb_form", "Nominal verb form");

export const derivation = new Cwb_PositionalAttribute("derivation", "Derivation");

export const descr = new Cwb_PositionalAttribute("descr", "Description");

export const nlex = new Cwb_PositionalAttribute("nlex", "Non-lexical");

export const list = ofArray([lemma, pos, subclass, grade, number, case$, attribute, person_number, mood, tense, nominal_verb_form, derivation, descr, nlex]);

